import { apiRequest } from "../api";

export const getDashboard = () => apiRequest("/dashboard", "GET");
